import {validateRequired, validateEmail, validatePhoneNumber} from './ValidationFunctions';

export const userAddConfig = {
  fields: {
    email: {
      type: 'text',
      label: 'Email *',
      rules: [validateRequired('Email'), validateEmail]
    },
    phones: {
      type: 'text',
      label: 'Phone number',
      rules: [validatePhoneNumber]
    },
    firstName: {
      type: 'text',
      label: 'First name *',
      rules: [validateRequired('First name')]
    },
    lastName: {
      type: 'text',
      label: 'Last name *',
      rules: [validateRequired('Last name')]
    },
    roleGuid: {
      type: 'select',
      label: 'Role *',
      options: (props) => {
        return props.rolesOptions
      },
      value: 'guid',
      optionLabel: 'name',
      rules: [validateRequired('Role')]
    },
    employeeIdentifier: {
      type: 'text',
      label: 'Employee ID',
      rules: []
    },
    photo: {
      type: 'uploadUserPhoto',
      label: '',
      rules: []
    }
  }
};

export const userEditConfig = {
  fields: {
    email: {
      type: 'text',
      label: 'Email *',
      rules: [validateRequired('Email'), validateEmail]
    },
    firstName: {
      type: 'text',
      label: 'First name *',
      rules: [validateRequired('First name')]
    },
    lastName: {
      type: 'text',
      label: 'Last name *',
      rules: [validateRequired('Last name')]
    },
    employeeIdentifier: {
      type: 'text',
      label: 'Employee ID',
      rules: []
    }
  }
};

export const oitChangeDivisionConfig = {
  fields: {
    divisionGuid: {
      type: 'select',
      label: 'Division *',
      options: (props) => {
        return props.divisionsOptions
      },
      value: 'guid',
      optionLabel: 'name',
      rules: [validateRequired('Division')]
    }
  }
};
